"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copperOreStorageConfig = void 0;
exports.copperOreStorageConfig = {
    name: 'storage-copper-ore',
    fullname: 'Copper Ore Storage',
    description: 'Storage for copper ore, keeping it at the perfect humidity and temperature.',
    type: 'storage',
    width: 1,
    height: 1,
    levelMax: 9,
    canBeDisabled: false,
    requiredTechnology: 'ores',
    levels: [
        { level: 0, constructionCosts: {}, time: 1, provides: {}, costs: {}, stores: { 'copper-ore': 10 } },
        { level: 1, constructionCosts: { iron: 5 }, time: 1, provides: {}, costs: {}, stores: { 'copper-ore': 20 } },
        { level: 2, constructionCosts: { iron: 10 }, time: 1, provides: {}, costs: {}, stores: { 'copper-ore': 40 } },
        { level: 3, constructionCosts: { iron: 30 }, time: 1, provides: {}, costs: {}, stores: { 'copper-ore': 100 } },
        { level: 4, constructionCosts: { iron: 70 }, time: 1, provides: {}, costs: {}, stores: { 'copper-ore': 200 } },
        { level: 5, constructionCosts: { iron: 150 }, time: 1, provides: {}, costs: {}, stores: { 'copper-ore': 400 } },
        { level: 6, constructionCosts: { iron: 300 }, time: 1, provides: {}, costs: {}, stores: { 'copper-ore': 1000 } },
        { level: 7, constructionCosts: { iron: 500 }, time: 1, provides: {}, costs: {}, stores: { 'copper-ore': 2000 } },
        { level: 8, constructionCosts: { iron: 1000 }, time: 1, provides: {}, costs: {}, stores: { 'copper-ore': 3000 } },
        { level: 9, constructionCosts: { iron: 2000 }, time: 1, provides: {}, costs: {}, stores: { 'copper-ore': 5000 } },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/copperorestorage.js
// module id = Kfbz
// module chunks = 0